module.exports = __webpack_public_path__ + "752e52840dd59a503675cab5ea0fb4f4.png";